module.exports = __webpack_public_path__ + "static/media/EditItem.2601755d.svg";